import { render } from "./mat-textarea.vue?vue&type=template&id=5a00c285&lang=true"
import script from "./mat-textarea.vue?vue&type=script&lang=js"
export * from "./mat-textarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__